var __jsx = React.createElement;
import React, { useEffect } from 'react';
import useBoolean from '@hooks/useBoolean';
import { useDynamicForm } from '@/pages/finance-eligibility/context/ScreenContext';
var AnimatedCard = function AnimatedCard(_ref) {
  var children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  var active = useBoolean();
  var _useDynamicForm = useDynamicForm(),
    currentStep = _useDynamicForm.currentStep;
  useEffect(function () {
    active.setFalse();
    var timer = setTimeout(function () {
      active.setTrue();
    }, 200);
    return function () {
      clearTimeout(timer);
    };
  }, [currentStep.key]);
  return /*#__PURE__*/React.createElement("div", {
    className: "transition-all duration-700 ease-in-out transform ".concat(active.value ? 'translate-y-0 opacity-100' : 'translate-y-[50%] opacity-0', " ").concat(className)
  }, children);
};
export default AnimatedCard;